class WhatsappFloatChroxel extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('.whatsapp-float-chroxel__toggle');
    this.closeButton = this.querySelector('[data-wa-close]');
    this.scrollOffset = parseInt(this.dataset.scrollOffset, 10);
    if (Number.isNaN(this.scrollOffset)) this.scrollOffset = 1000;
    this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    this._ticking = false;
    this._closeTimer = null;

    this.onScroll = this.onScroll.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.scheduleClose = this.scheduleClose.bind(this);
    this.cancelClose = this.cancelClose.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    if (this.toggleButton) this.toggleButton.addEventListener('click', this.toggle);
    if (this.closeButton) this.closeButton.addEventListener('click', this.close);

    if (this.hoverCapable) {
      // Desktop: reveal on hover, close shortly after leaving so crossing the
      // gap between button and card doesn't dismiss it.
      this.addEventListener('mouseenter', this.cancelClose);
      this.addEventListener('mouseenter', this.open);
      this.addEventListener('mouseleave', this.scheduleClose);
    } else {
      // Touch: close when tapping outside the widget.
      document.addEventListener('click', this.onDocumentClick);
    }

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.updateVisibility();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('click', this.onDocumentClick);
    this.cancelClose();
  }

  onScroll() {
    if (this._ticking) return;
    this._ticking = true;
    requestAnimationFrame(() => {
      this.updateVisibility();
      this._ticking = false;
    });
  }

  updateVisibility() {
    const visible = window.scrollY > this.scrollOffset;
    this.classList.toggle('is-visible', visible);
    if (!visible) this.close();
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  open() {
    if (!this.classList.contains('is-visible')) return;
    this.classList.add('is-open');
    if (this.toggleButton) this.toggleButton.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-open');
    if (this.toggleButton) this.toggleButton.setAttribute('aria-expanded', 'false');
  }

  toggle(event) {
    event.preventDefault();
    this.classList.contains('is-open') ? this.close() : this.open();
  }

  scheduleClose() {
    this.cancelClose();
    this._closeTimer = window.setTimeout(this.close, 250);
  }

  cancelClose() {
    if (this._closeTimer) {
      window.clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
  }
}

customElements.define('whatsapp-float-chroxel', WhatsappFloatChroxel);
